<template>
  <div>
    <page-title-bar></page-title-bar>
    <v-container fluid grid-list-xl pt-0>
      <v-layout row wrap>
        <app-card :fullBlock="true" colClasses="xs12">
          <v-container>
            <v-layout pa-3 v-if="saleInfo" wrap>
              <v-flex xs12 sm6>
                <h3>{{ $t("message.status") }}</h3>

                <v-alert
                  :value="true"
                  color="light-green accent-4"
                  icon="info"
                  v-if="saleInfo.status === 2"
                  outline
                  >{{ $t("message.verified") }}</v-alert
                >
                <v-alert
                  :value="true"
                  color="error"
                  icon="info"
                  v-else-if="saleInfo.status === 1"
                  outline
                  >{{ $t("message.cancelled") }}</v-alert
                >
                <v-alert
                  :value="true"
                  color="yellow"
                  icon="info"
                  v-else-if="saleInfo.status === 3"
                  outline
                  >{{ $t("message.pending") }}</v-alert
                >
                <v-alert
                  :value="true"
                  color="warning"
                  icon="info"
                  v-else-if="saleInfo.status === 4"
                  outline
                  >{{ $t("message.verify") }}</v-alert
                >
              </v-flex>

              <v-flex xs12>
                <h3>{{ $t("message.client") }}</h3>

                <v-layout row wrap>
                  <v-flex xs12 sm6>
                    <v-text-field
                      readonly
                      :label="$t('message.name')"
                      v-model="saleInfo.ticket_user.name"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6>
                    <v-text-field
                      readonly
                      :label="$t('message.lastname')"
                      v-model="saleInfo.ticket_user.lastname"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs12 sm6>
                    <v-text-field
                      readonly
                      :label="$t('message.email')"
                      v-model="saleInfo.ticket_user.email"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6>
                    <v-text-field
                      readonly
                      :label="$t('message.telephone')"
                      v-model="saleInfo.ticket_user.phone"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs12>
                <h3>Método de pago </h3>

                <v-textarea
                  no-resize
                  :rows="2"
                  readonly
                  label
                  :value="saleInfo.note"
                ></v-textarea>
              </v-flex>

              <v-flex xs12 v-if="saleInfo.payment_id">
                <h3>Datos del pago movil</h3>

                <v-layout row wrap>

                  <v-flex xs12 sm6>
                    <v-text-field
                      readonly
                      :label="$t('Ci/Rif')"
                      v-model="saleInfo.payment_id"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6>
                    <v-text-field
                      readonly
                      :label="$t('Telefono')"
                      v-model="saleInfo.payment_number"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                
              </v-flex>

              <v-flex xs12 v-if="saleInfo.zelle_code">
                <h3>Pago con zelle </h3>

                <v-layout row wrap>

                  <v-flex xs12 sm6>
                    <v-text-field
                      readonly
                      :label="$t('Codigo zelle')"
                      v-model="saleInfo.zelle_code"
                    ></v-text-field>
                  </v-flex>

                </v-layout>
                
              </v-flex>

              <v-flex xs12 v-if="saleInfo.image_url">
                <h3>{{ $t("message.receiptImage") }}</h3>
                <v-img
                  :src="saleInfo.image_url"
                  @click="onReceipt"
                  aspect-ratio="1"
                  class="grey lighten-2"
                  max-height="200"
                ></v-img>
              </v-flex>

              <v-flex xs12 v-if="saleInfo.image_url">
                <p> si la imagen sale rota: </p>
		<a target="_blank" v-bind:href="saleInfo.image_url"> click aqui </a>
              </v-flex>

              <v-flex xs12 v-if="saleInfo">
                <h3>{{ $t("message.order") }}</h3>

                <v-data-table
                  :headers="headers"
                  :items="tableData()"
                  hide-actions
                >
                  <template slot="headerCell" slot-scope="props">
                    <v-tooltip bottom>
                      <span slot="activator">{{
                        $t(`message.${props.header.text}`)
                      }}</span>
                      <span>{{ $t(`message.${props.header.text}`) }}</span>
                    </v-tooltip>
                  </template>
                  <template slot="items" >
                    <td>{{ saleInfo.event_name }}</td>
                    <td>{{ saleInfo.price + " $" }}</td>
                    <td>{{ saleInfo.quantity }}</td>
                    <td>{{ saleInfo.event_description || "Ninguna" }}</td>
                    <td>{{ saleInfo.ticket_section || "N/A" }}</td>
                    <td>{{ saleInfo.ticket_quantity || "N/A" }}</td>
                    <td>{{ saleInfo.description || "N/A" }}</td>
                    <td>
                      {{ saleInfo.total_price + " $" }}
                    </td>
                  </template>
                </v-data-table>
              </v-flex>

              <v-flex xs12>
                <v-layout pa-3>
                  <v-flex v-if="saleInfo.dollar_price">
                    <p>
                      <strong>{{ $t("message.exchangeRate") }}:</strong>
                      {{
                        Number(saleInfo.dollar_rate).toLocaleString("de-DE", {
                          style: "currency",
                          currency: "VES",
                        })
                      }}
                    </p>
                    <p>
                      <strong>{{ $t("message.totalInVes") }}:</strong>
                      {{
                        saleInfo.local_amount
                      }}
                    </p>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
          <v-container v-if="saleInfo && saleInfo.status > 2">
            <v-flex>
              <v-flex xs12>
                <v-layout justify-end>
                  <v-flex shrink>
                    <v-btn
                      outline
                      @click="onDenyPayment"
                      :loading="confirmPaymentLoading"
                      color="error"
                      >{{ $t("message.denyPayment") }}</v-btn
                    >
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12>
                <v-layout>
                  <v-flex shrink>
                    <v-btn
                      outline
                      @click="onConfirmPayment"
                      :loading="confirmPaymentLoading"
                      color="primary"
                      >{{ $t("message.confirmPayment") }}</v-btn
                    >
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-flex>
          </v-container>
        </app-card>
      </v-layout>
      <receipt-image
        :dialog.sync="openReceiptModal"
        ref="receiptModal"
      ></receipt-image>
    </v-container>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { userRoles, purchaseStatus, paymentStatus } from "../../../constants/constants";
import {
  GET_SALE,
  CHANGE_SALE_STATUS,
} from "../../../store/modules/sales/actionTypes";
import ReceiptImage from "../../shopping/ReceiptImage";
import PurchaseStatus from "../../custom/PurchaseStatus";
import CancelPurchase from "../../custom/CancelPurchase";

const initLat = null;
const initLng = null;

export default {
  name: "shoppingDetails",
  components: {
    ReceiptImage,
    PurchaseStatus,
    CancelPurchase,
  },
  data() {
    return {
      openReceiptModal: false,
      confirmPaymentLoading: false,
      headers: [
        {
          text: "name",
          sortable: false,
          align: "center",
          value: "name",
        },
        {
          text: "price",
          sortable: false,
          align: "center",
          value: "dollar_amount",
        },
        {
          text: "quantity",
          sortable: false,
          align: "center",
          value: "quantity",
        },
        {
          text: "description",
          sortable: false,
          align: "center",
          value: "description",
        },
        {
          text: "section",
          sortable: false,
          align: "center",
          value: "section",
        },
        {
          text: "ticket_quantity",
          sortable: false,
          align: "center",
          value: "ticket_quantity",
        },
        {
          text: "text",
          sortable: false,
          align: "center",
          value: "text",
        },
        { text: "total", sortable: false, align: "center", value: "total" },
      ],
      purchaseStatus: purchaseStatus,
      userRoles: userRoles,
      paymentStatus: {
        'confirm': 1,
        'deny': 0
      },
      billStatus: {
        'denied': 1,
        'verified': 2,
        'pending': 3,
      }
    };
  },
  computed: {
    ...mapGetters(["singleSale", "getUser"]),
    saleInfo() {
      return this.singleSale(this.salesId);
    },
  },
  created() {
    this.salesId = this.$route.params.id;
    this[GET_SALE](this.salesId);
  },
  methods: {
    ...mapActions([GET_SALE, CHANGE_SALE_STATUS]),
    tableData() {
      // const { event_name, dollar_amount, event_description } = this.saleInfo;
      return [
        {
          // name: event_name,
          // dollar_amount,
          // description: event_description,
        },
      ];
    },
    onReceipt() {
      this.$refs.receiptModal.setValue(this.saleInfo.image_url);
      this.openReceiptModal = true;
    },
    async onConfirmPayment() {
      this.confirmPaymentLoading = true;
      await this[CHANGE_SALE_STATUS]({ id: this.salesId, value:  this.paymentStatus['confirm'] });
      this.confirmPaymentLoading = false;
    },
    async onDenyPayment() {
      this.confirmPaymentLoading = true;
      await this[CHANGE_SALE_STATUS]({ id: this.salesId, value: this.paymentStatus['deny'] });
      this.confirmPaymentLoading = false;
    },
  },
};
</script>

<style scoped>
.v-alert {
  margin: 4px 0;
}
.receipt-image {
  height: 14em;
  max-width: 10em;
  cursor: pointer;
  border: 1px solid black;
}

.map-style {
  height: 16em !important;
  z-index: 1 !important;
}

td {
  text-align: center;
}
</style>
